import React, { useContext } from 'react';
import styled from 'styled-components';
import LoginController from '../../controller/LoginController';

interface LoginFindMainProps {
  findIdSuccess: boolean;
  findPasswordSuccess: boolean;
  typeForgot: string;
  moveLoginPage: () => void;
  moveFindPasswordPage: () => void;
  findId: any;
  storeId: number;
  authenticationKey: number;
}

export const LoginFindSuccess = ({
  findIdSuccess,
  findPasswordSuccess,
  typeForgot,
  moveLoginPage,
  moveFindPasswordPage,
  findId,
  storeId,
  authenticationKey,
}: LoginFindMainProps) => {
  const [changePassword, setChangePassword] = React.useState<string>('');
  const [checkChangePassword, setCheckChangePassword] = React.useState<string>('');
  const [changePasswordErrorText, setChangePasswordErrorText] = React.useState<string>('');
  const [successChangePassword, setSuccessChangePassword] = React.useState<boolean>(false);

  // 비밀번호 변경하기
  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === 'changePassword') {
      setChangePassword(value);
    } else if (name === 'checkChangePassword') {
      setCheckChangePassword(value);
    }
  };

  const changePasswordButton = () => {
    if (changePassword === '' && checkChangePassword === '') {
      setChangePasswordErrorText('비밀번호가 입력되지 않았습니다.');
    } else if (changePassword !== checkChangePassword) {
      setChangePasswordErrorText('비밀번호가 일치하지 않습니다.');
    } else {
      changePwdByfindPwd();
    }
  };

  // api_비밀번호 변경
  const changePwdByfindPwd = async () => {
    let oData: any = {
      store_type: 1,
      email: findId[0],
      password: changePassword,
      password_check: checkChangePassword,
      key: authenticationKey,
    };

    try {
      const oResp = await LoginController.changePwdByfindPwd(oData);

      let oResponse = oResp?.data;
      if (oResponse.ok === true && oResponse !== undefined) {
        setSuccessChangePassword(true);
      } else {
        setChangePasswordErrorText(oResponse.msg);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  return (
    <Style>
      <div className="successWrap">
        <div>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_forget_check.svg`} alt="찾기완료 아이콘" />
          {/* 아이디찾기 */}
          {findIdSuccess && typeForgot === 'id' && (
            <div className="successContent">
              <h3>아이디 확인 결과입니다</h3>
              <div className="successBox">
                {findId.map((item: any, index: string) => (
                  <h2 key={index}>{`${item.email}`}</h2>
                ))}
              </div>
              <button onClick={moveLoginPage} className="pageMoveButton">
                로그인 화면으로
              </button>
              <button onClick={moveFindPasswordPage} className="backPageButton">
                <p>비밀번호 찾기</p>
              </button>
            </div>
          )}

          {/* 비밀번호 변경하기 */}
          {findPasswordSuccess && typeForgot === 'password' && (
            <div className="successContent">
              {!successChangePassword && (
                <div className="changePassword">
                  <h3>비밀번호를 변경해주세요</h3>
                  <input
                    type="password"
                    placeholder="비밀번호를 입력해 주세요."
                    name="changePassword"
                    value={changePassword}
                    onChange={handlePasswordChange}
                    style={{ border: changePasswordErrorText !== '' ? '1px solid #FDA29B' : '' }}
                  />
                  <input
                    type="password"
                    placeholder="비밀번호를 한번 더 입력해주세요."
                    name="checkChangePassword"
                    value={checkChangePassword}
                    onChange={handlePasswordChange}
                    style={{ border: changePasswordErrorText !== '' ? '1px solid #FDA29B' : '' }}
                  />
                  <div className="errorMessage">
                    <p>{changePasswordErrorText}</p>
                  </div>
                  <button onClick={changePasswordButton} className="changePasswordButton">
                    비밀번호 변경 완료
                  </button>
                </div>
              )}
              {successChangePassword && (
                <div className="changePassword">
                  <div className="successNotice">
                    <p>
                      비밀번호 찾기가 완료되었습니다.
                      <br /> 새로운 비밀번호가 변경되었습니다.
                    </p>
                  </div>
                  <button onClick={moveLoginPage} className="pageMoveButton">
                    로그인 페이지로 돌아가기
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </Style>
  );
};

export const Style = styled.div`
  /* successWrap */
  .successWrap {
    img {
      display: flex;
      margin: 0 auto;
    }

    img {
      margin-bottom: 40px;
    }
  }
  .successContent {
    h3 {
      margin-bottom: 8px;
      font-size: 14px;
      font-weight: 600;
      color: #a7a7a7;
      text-align: center;
    }
    h2 {
      margin: 3px 0;
      font-size: 16px;
      font-weight: 600;
      line-height: 30px;
      color: #555;
      text-align: center;
    }
  }
  .successBox {
    margin-top: 33px;
    padding: 33px;
    border: 1px solid #cecece;
    border-radius: 10px;
  }
  .pageMoveButton,
  .changePasswordButton {
    width: 100%;
    padding: 16px;
    margin-top: 32px;
    background: #4dd2ae;
    color: #fff;
    border-radius: 8px;
    border: none;
    outline: none;
    font-size: 18px;
    font-weight: 600;
  }
  .backPageButton {
    margin-top: 36px;
  }

  /* 비밀번호 변경 */
  .changePassword {
    margin-top: 24px;

    input {
      width: 100%;
      margin-top: 6px;
      padding: 10px 14px;
      border: 1px solid #d0d5dd;
      border-radius: 8px;
      outline: none;
    }
  }
  .successNotice {
    padding: 24px;
    border: 1px solid #d8dbdf;
    text-align: center;
    border-radius: 8px;
    p {
      font-size: 16px;
      font-weight: 500;
      color: #26282c;
      line-height: 24px;
    }
  }

  /* errorMessage */
  .errorMessage {
    width: 100%;

    p {
      margin: 6px 0 0 0;
      font-size: 14px;
      font-weight: 400;
      color: #f04438;
    }
  }
`;
